export default __webpack_public_path__ + "static/media/NCFirstClass_Logo-Variations-01.f9d05af2.png";